function setLocalStorage (key, value) {
  if (value === null) {
    localStorage.removeItem(key)
  } else {
    localStorage.setItem(key, value)
  }
}

export const setBungieToken = (state, {bungieToken}) => {
  state.bungieToken = bungieToken
  setLocalStorage('bungieToken', bungieToken)
}

export const setTokenExpiration = (state, {tokenExpiration}) => {
  state.tokenExpiration = tokenExpiration
  setLocalStorage('tokenExpiration', tokenExpiration)
}

export const setMembershipId = (state, {membershipId}) => {
  state.membershipId = membershipId
  setLocalStorage('membershipId', membershipId)
}



// WEBPACK FOOTER //
// ./src/store/auth/mutations.js